import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import { action } from 'satcheljs/lib/legacy';

export default action('updateFindResultTransactionId')(function updateFindResultTransactionId(
    recipientWell: FindControlViewState,
    responseMessage?: any
) {
    let transactionId = '';
    if (responseMessage) {
        if (isFeatureEnabled('rp-3SPeopleSuggestions')) {
            let response = responseMessage as SubstrateSearchSuggestionsResponse;
            if (response.Groups && response.Instrumentation) {
                transactionId = response.Instrumentation.TraceId;
            }
        } else {
            let response = responseMessage as FindPeopleResponseMessage;
            if (response.ResponseClass == 'Success' && response.ResultSet) {
                transactionId = response.TransactionId;
            }
        }
    }

    recipientWell.findResultTransactionId = transactionId;
});
